
import { defineComponent } from "vue";
import { PoweredBy } from "./";
import { mapGetters } from "vuex";
import * as bs from "bootstrap";
import { useUserFlagsStore } from "@/stores/userFlags";
import { useMenuStore, MenuItem } from "@/stores/menu";
import { useUiPreferencesStore } from "@/stores/uiPreferences";
import { shouldShowInView, VIEW_MODE } from "@/utils/menuScope";
import { sharpIcon } from "@/utils/sharpIcon";

export default defineComponent({
  name: "dashboard-sidebar",
  components: { PoweredBy },
  inject: {
    menus: { from: "menus-definition" },
  },
  data() {
    return {
      menuDiv: {} as any,
    };
  },
  computed: {
    ...mapGetters("auth", ["getUserPermissions"]),
    ...mapGetters("auth", ["getUserRole"]),
    ...mapGetters("subs", ["getUserSubscription"]),
    userFlagsStore() {
      return useUserFlagsStore();
    },
    menuStore() {
      return useMenuStore();
    },
    uiPreferencesStore() {
      return useUiPreferencesStore();
    },
    menu(): Array<MenuItem> {
      const currentView = this.userFlagsStore.isAdminView
        ? VIEW_MODE.ADMIN
        : VIEW_MODE.USER;

      const menu = this.menuStore.menus.filter((item: any) => {
        // First check permissions
        if (!this.getUserPermissions.includes(item.Key)) {
          return false;
        }

        // Then check scope using utility function
        return shouldShowInView(item.Scope, currentView);
      });
      return menu;
    },
  },
  methods: {
    hideMenu() {
      this.menuDiv.hide();
    },
    sharpIcon,
  },
  mounted() {
    const menuDiv = document.getElementById("main-menu");
    this.menuDiv = new bs.Collapse(menuDiv, {
      toggle: false,
    });
  },
});
